"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmation = exports.ConfirmationAction = exports.Confirmation = void 0;
var tslib_1 = require("tslib");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Confirmation_1 = require("@reactionable/core/lib/ui/confirmation/Confirmation");
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
var Modal_1 = tslib_1.__importDefault(require("react-bootstrap/Modal"));
var react_i18next_1 = require("react-i18next");
exports.Confirmation = function (_a) {
    var callback = _a.callback, children = _a.children, title = _a.title;
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(Modal_1.default, { show: true, size: "lg", "aria-labelledby": "contained-modal-title-vcenter", centered: true, onHide: function () { return callback(false); } },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, { id: "contained-modal-title-vcenter" }, title || t('Confirm ?'))),
        react_1.default.createElement(Modal_1.default.Body, null, children),
        react_1.default.createElement(Modal_1.default.Footer, null,
            react_1.default.createElement(Button_1.default, { variant: "outline-primary", onClick: function () { return callback(false); } }, t('Cancel')),
            react_1.default.createElement(Button_1.default, { variant: "primary", onClick: function () { return callback(true); } }, t('OK')))));
};
function ConfirmationAction(_a) {
    var label = _a.label, button = _a.button, icon = _a.icon, children = _a.children, props = tslib_1.__rest(_a, ["label", "button", "icon", "children"]);
    return (react_1.default.createElement(Confirmation_1.ConfirmationAction, tslib_1.__assign({}, props),
        children,
        button && (react_1.default.createElement(Button_1.default, tslib_1.__assign({ title: props.title || '' }, button),
            icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, tslib_1.__assign({}, icon)),
            label))));
}
exports.ConfirmationAction = ConfirmationAction;
exports.useConfirmation = function (props) {
    return Confirmation_1.useConfirmation(tslib_1.__assign({ Component: exports.Confirmation }, props));
};
//# sourceMappingURL=Confirmation.js.map